<template>
    <span>
        <span v-if="bold">
            <span class="secondary--text"><strong>K</strong></span><span class="primary--text">eywords</span> <span class="secondary--text"><strong>P</strong></span><span class="primary--text">icker</span>
        </span>
        <span v-else>
            <span class="secondary--text">K</span><span class="primary--text">eywords</span> <span class="secondary--text">P</span><span class="primary--text">icker</span>
        </span>
    </span>
</template>

<script>
export default {

    name: 'Shared_Title',

    props: {
        bold: {
            type: Boolean,
            default: false
        }
    }

}
</script>